'use strict';

/**
 * Override Webpack public path.
 */
__webpack_public_path__ = ( window.wp_env.publicPath !== undefined ) ? window.wp_env.publicPath : null;

/**
 * Import jQuery
 */
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "$" }] */
import $ from 'jquery';

/**
 * Import environment variables.
 */
import getSettings from './settings/env.js';
window.app = getSettings();

/**
 * Import other modules.
 */
import { viewportUnits } from './helpers/viewport-units.js';
import * as uiFeatures from './ui.js';
import { logFocus } from './helpers/log-focus.js';

logFocus();

/**
 * Load webfonts.
 */
import WebFont from 'webfontloader';

// Load webfonts
WebFont.load( {
  custom: {
    families: [ 'Open Sans:n4,i4,n6,i6,n7,i7' ]
  },
  active: function() {
    let event = new CustomEvent( 'webfontsLoaded' );
    window.dispatchEvent( event );
  },
  inactive: function() {
    let event = new CustomEvent( 'webfontsError' );
    window.dispatchEvent( event );
  }
} );

/**
 * Add CSS class 'lazyloaded' to lazyloaded image parents with CSS class 'js-has-lazyload' on load.
 */
$( document ).on( 'lazyloaded', function( e ) {
  $( e.target ).parents( '.js-has-lazyload' ).addClass( '-lazyloaded' );
} );

/**
 * Initialize our base app.
 */
const initUi = function() {

  /*
   * Provide global settings.
   */
  window.app = getSettings();

  /*
   * Run helper functions.
   */
  viewportUnits();

  /*
   * Init UI feature modules.
   */
  Object.keys( uiFeatures )
    .forEach(
      function( key ) {
        uiFeatures[ key ]();
      }
    );

  /*
   * Initialize async components here.
   */

  const pagination = document.querySelectorAll( '.js-pagination' );
  if ( pagination.length > 0 ) {
    import(/* webpackChunkName: "pagination" */ './components/pagination.js' )
      .then(
        component => {
          pagination.forEach( function( pagination ) {
            new component.Pagination( pagination ).init();
          } );
        }
      );
  }

  const sliders = document.querySelectorAll( '.js-slider' );
  if ( sliders.length > 0 ) {
    import(/* webpackChunkName: "slider" */ './components/slider.js' )
      .then(
        component => {
          sliders.forEach( function( slider ) {
            if ( slider.classList.contains( 'js-slider--posts' ) ) {
              new component.PostSlider( slider ).init();
            }
            else if ( slider.classList.contains( 'js-slider--quotes' ) ) {
              new component.QuoteSlider( slider ).init();
            }
            else if ( slider.classList.contains( 'js-slider--timeline' ) ) {
              new component.TimelineSlider( slider ).init();
            }
            else if ( slider.classList.contains( 'js-slider--fade' ) ) {
              new component.FadeSlider( slider ).init();
            }
          } );
        }
      );
  }

  const countup = document.querySelectorAll( '.js-countup' );
  if ( countup.length > 0 ) {
    import(/* webpackChunkName: "countup" */ './components/countup.js' )
      .then(
        component => {
          countup.forEach( function( countup ) {
            new component.Countup( countup ).init();
          } );
        }
      );
  }

  const snow = document.querySelectorAll( '.js-snow' );
  if ( snow.length > 0 ) {
    import(/* webpackChunkName: "snow" */ './components/snow.js' )
      .then(
        component => {
          snow.forEach( function( snow ) {
            new component.Snow( snow ).init();
          } );
        }
      );
  }


  document.removeEventListener( 'DOMContentLoaded', initUi );
}

if ( /comp|inter|loaded/.test( document.readyState ) ) {
  // In case DOMContentLoaded was already fired, the document readyState will be one of "complete" or "interactive" or (nonstandard) "loaded".
  // The regexp above looks for all three states. A more readable regexp would be /complete|interactive|loaded/.
  initUi();
} else {
  // In case DOMContentLoaded was not yet fired, use it to run the "start" function when document is read for it.
  document.addEventListener( 'DOMContentLoaded', initUi, false );
}
